import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HomeItemComponent } from '@app/modules/home-item-detail/components/home-item/home-item.component';
import {
  SearchBarMobileCalendarContainer
} from '@shared/base-search-bar/components/calendar/components/search-bar-mobile-calendar/search-bar-mobile-calendar.container';

export const homeItemDetailRootRoute = 'home-item-detail';
export const calendarRoute = 'calendar';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: ':name/:code',
        component: HomeItemComponent,
        children: [
          {
            path: calendarRoute,
            outlet: 'search',
            component: SearchBarMobileCalendarContainer,
          }
        ]
      }
    ])
  ],
  exports: [RouterModule]
})
export class HotelItemDetailRoutingModule { }
